import { render, staticRenderFns } from "./FullSyncStatus.vue?vue&type=template&id=f7fa08fe&"
import script from "./FullSyncStatus.vue?vue&type=script&lang=js&"
export * from "./FullSyncStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports